import { render, staticRenderFns } from "./VNameAndAvatar.vue?vue&type=template&id=215c2ed2&"
import script from "./VNameAndAvatar.vue?vue&type=script&lang=ts&"
export * from "./VNameAndAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports